import { jsxs as P, jsx as o, Fragment as pe } from "react/jsx-runtime";
import { useRef as V, useState as C, useEffect as _ } from "react";
import { u as d } from "./index-6a632112.mjs";
import { s as n, j as fe, o as s, r as ae, b as U, k as te, e as re, c as k, Q as me } from "./themes-5f0b3c3d.mjs";
import { l as q } from "./lineHeights-72d3110c.mjs";
import { t as H } from "./textStyles-42cab346.mjs";
import { S as ie } from "./cancelCloseFilled-b2127cb6.mjs";
import { S as le } from "./caretDown-8ff83493.mjs";
import { S as se } from "./caretUp-e6db3a6f.mjs";
import { L as he } from "./label-3b996c7d.mjs";
import { u as ue } from "./uniqueId-321287e8.mjs";
import { useAccessibilityProps as ce } from "./accessibility.js";
import { D as E } from "./index-39f84169.mjs";
import { TagsGroup as ge } from "./tags.js";
import { H as $e } from "./helperText-698f3ed9.mjs";
import { ScreenReaderOnly as be } from "./screenReaderOnly.js";
import { TextInput as xe } from "./textInput.js";
import "./fontWeights-a25f8f91.mjs";
import "./types-b577bf77.mjs";
import "./tooltip.js";
import "./useWindowDimensions.js";
import "./zIndices-d07533f3.mjs";
import "./getElementPosition-5026bb28.mjs";
import "./popupTip.js";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./iconButton.js";
import "./button.js";
import "./checkmarkFilled-c2b01ef1.mjs";
import "./informationFilled-05d57719.mjs";
import "./radio.js";
import "./warningFilled-691cfde1.mjs";
import "./checkbox.js";
import "./checkmark-84b5274e.mjs";
import "./subtract-848336fd.mjs";
import "./menu.js";
import "./moreVertical-dc2e97a2.mjs";
const ye = d.div`
  display: flex;
  flex-direction: column;
  gap: ${n["2x"]};
  div {
    margin-bottom: unset !important;
  }
`, ve = d.div`
  --select-input-height: ${({ size: e }) => {
  switch (!0) {
    case e === "large":
      return n["12x"];
    case e === "medium":
      return n["10x"];
    case e === "small":
      return n["8x"];
    default:
      return n["10x"];
  }
}};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${n["2x"]};
  position: relative;
  width: auto;
  min-height: var(--select-input-height);
  background-color: ${(e) => e.$isDisabled ? fe.disabled : "#ffffff"};
  outline: ${(e) => `1px solid ${e.$isDisabled ? s.disabled : e.$inputState === "error" ? s.danger : e.$inputState === "caution" ? s.caution : e.$isOpen ? s.focus : s.default}`};
  border: ${(e) => `${e.$isOpen ? `1px solid ${e.$isDisabled ? s.disabled : e.$inputState === "error" ? s.danger : e.$inputState === "caution" ? s.caution : e.$isOpen ? s.focus : s.default}` : "none"}`};
  border-radius: ${ae["2x"]};
  cursor: ${(e) => e.$isDisabled ? "default" : "pointer"};
  padding: ${n["1x"]} ${n["3x"]};
  box-sizing: border-box;
  &:focus-within {
    outline-width: ${U["1x"]};
    outline-color: ${(e) => e.$inputState === "error" ? s.danger : e.$inputState === "caution" ? s.caution : s.focus};
    border-width: ${U["1x"]};
    border-color: ${(e) => e.$inputState === "error" ? s.danger : e.$inputState === "caution" ? s.caution : s.focus};
  }
  &:hover {
    ${(e) => e.$inputState === "none" && !e.$isDisabled && !e.$isOpen && `outline: ${U["1x"]} solid ${s["primary-strong"]}`};
  }
`, we = d.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: ${n["3x"]};
  div {
    margin-bottom: 0px;
  }
`, Se = d.input`
  --input-font-size: ${({ size: e }) => {
  switch (!0) {
    case e === "large":
      return H.body.medium.l.fontSize;
    case e === "medium":
      return H.body.medium.m.fontSize;
    case e === "small":
      return H.body.medium.s.fontSize;
    default:
      return H.body.medium.m.fontSize;
  }
}};
  --input-line-height: ${({ size: e }) => {
  switch (!0) {
    case e === "large":
      return q.large;
    case e === "medium":
      return q.medium;
    case e === "small":
      return q.small;
    default:
      return q.medium;
  }
}};
  font-size: var(--input-font-size);
  line-height: var(--input-line-height);
  border: none;
  background-color: transparent;
  font-family: ${te};
  font-weight: ${re.regular.S.fontWeight};
  color: ${k.brandTwilight[1e3]};
  &:focus {
    outline: none;
  }
  &:disabled {
    color: ${k.brandTwilight[500]};
    cursor: default;
  }
  &::placeholder {
    font-family: ${te};
    font-size: ${H.body.medium.m.fontSize};
    font-weight: ${re.regular.S.fontWeight};
    color: ${k.brandTwilight[600]};
  }
  @media ${me.mobile} {
    width: 100%;
  }
`, Ie = d.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${n["6x"]};
  width: ${n["6x"]};
  color: ${k.brandTwilight[800]};
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: ${n["1x"]};
  &:disabled {
    cursor: auto;
  }
  &:focus-visible {
    border-radius: ${n["2x"]};
    outline: ${U["2x"]} solid ${k.accentBlue[1e3]};
    outline-offset: ${(e) => e.$isOffsetRequired ? "2px" : "unset"};
  }
`, Pe = d.button`
  display: flex;
  align-items: center;
  --dropwown-height-width: ${({ size: e }) => {
  switch (!0) {
    case e === "large":
      return n["6x"];
    case e === "medium":
      return n["6x"];
    case e === "small":
      return n["5x"];
    default:
      return n["6x"];
  }
}};
  svg {
    height: ${({ size: e }) => n[e === "small" ? "5x" : "6x"]};
    width: ${({ size: e }) => n[e === "small" ? "5x" : "6x"]};
  }
  display: flex;
  height: var(--dropwown-height-width);
  width: var(--dropwown-height-width);
  color: ${(e) => e.$isDisabled ? k.brandTwilight[400] : k.brandTwilight[1e3]};
  cursor: pointer;
  background-color: transparent;
  border: none;
  padding: 0px;
  justify-content: center;
  align-items: center;
  &:disabled {
    cursor: auto;
  }
  &:focus-visible {
    border: none;
    outline: none;
  }
`, ke = d.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  row-gap: ${n["3x"]};
  column-gap: ${n["2x"]};
  align-items: center;
  cursor: ${(e) => e.$isDisabled ? "auto" : "pointer"};
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
`, Oe = d.div`
  display: flex;
  gap: ${n["2x"]};
  align-items: center;
`, Ce = d.div`
  display: flex;
  justify-content: space-between;
  flex: 1;
`, ne = "MultiSelect", Ee = (e, v) => {
  let a = e.trim();
  return a = a?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), v.filter(
    (i) => `${i.label}${i.value}`.search(new RegExp(a, "i")) < 0
  ).map((i) => i.value);
}, bt = ({
  errorMessage: e,
  placeholder: v = "Select...",
  isDisabled: a = !1,
  options: i,
  selected: f,
  onOptionSelect: A,
  onClickClear: $,
  size: b = "medium",
  helperText: L = e,
  onChange: O,
  onBlur: D,
  isRequired: j = !1,
  required: T = j,
  isSelectAll: M = !1,
  className: F = "",
  labelProp: N,
  infoProp: Q,
  trailingText: X,
  isSearchable: z = !0,
  tagGroupProp: B,
  noResultText: K = "No result found",
  menuHeader: R,
  helperTextProp: p = {
    [e ? "secondaryProp" : "defaultProp"]: {
      helperText: L,
      id: `${e ? "invalid" : "valid"}_${ne}_helperText`,
      ...e && { state: "error" }
    }
  },
  ...h
}) => {
  const g = V(ue(h.id ?? ne)), w = Object.keys(f), l = V(null), [x, y] = C(""), [u, S] = C(!1), [m, J] = C([]);
  _(() => {
    J(Ee(x, i));
  }, [x, i]), _(() => {
    u === !0 ? l.current?.focus() : y("");
  }, [u]);
  const W = ce("combobox", {
    ariaExpanded: u,
    ariaDisabled: a,
    ariaRequired: T,
    ariaInvalid: p?.secondaryProp?.state === "caution" || p?.secondaryProp?.state === "error",
    ariaHasPopup: "listbox",
    ariaControls: g.current
  }), G = (t) => {
    $ && $(t), l.current?.focus();
  }, Y = (t) => {
    l.current?.focus(), t.target === t.currentTarget && S(!u);
  }, Z = (t, I) => {
    t.preventDefault(), A(I, t), l.current?.focus(), O && O(t);
  }, r = (t) => {
    y(t.target.value);
  };
  return /* @__PURE__ */ P(ye, { className: F, ...h, children: [
    /* @__PURE__ */ o(
      he,
      {
        labelProp: {
          showRequiredIndicator: T,
          htmlFor: h.id || g.current,
          ...N
        },
        infoProp: {
          infoText: "",
          infoType: "tooltip",
          popupTipHeader: "Info",
          ...Q
        },
        trailingText: X
      }
    ),
    /* @__PURE__ */ P(
      E,
      {
        menuOpen: !a && u,
        menuHeader: R || (M ? "select_all" : "default"),
        handleMenuOpen: (t) => S(t),
        onChange: Z,
        type: "multiple",
        isDisabled: a,
        uniqueIdentifier: g.current,
        hiddenItems: m,
        noResultText: K,
        children: [
          /* @__PURE__ */ o(E.Control, { children: /* @__PURE__ */ o(
            ve,
            {
              $inputState: p?.secondaryProp?.state !== "none" && (p.secondaryProp?.state === "caution" || p.secondaryProp?.state === "error") ? p?.secondaryProp?.state : "none",
              $isDisabled: a,
              $isOpen: u,
              size: b,
              onBlur: D,
              onKeyUp: (t) => {
                t.key === " " && t.stopPropagation(), u || S(!0);
              },
              children: /* @__PURE__ */ P(ke, { $isDisabled: a, children: [
                w.length > 0 && /* @__PURE__ */ o(
                  we,
                  {
                    onClick: Y,
                    onKeyDown: (t) => {
                      (t.key === "Enter" || t.key === " " && a) && (t.preventDefault(), t.stopPropagation());
                    },
                    children: B ? /* @__PURE__ */ o(ge, { ...B, children: w.map((t, I) => f[t]) }) : w.map((t, I) => f[t])
                  }
                ),
                /* @__PURE__ */ P(Ce, { children: [
                  /* @__PURE__ */ o(
                    Se,
                    {
                      id: g.current,
                      disabled: a,
                      placeholder: v,
                      onChange: r,
                      value: x,
                      size: b,
                      ref: l,
                      required: T,
                      readOnly: !z || R === "local_search",
                      onKeyDownCapture: (t) => {
                        t.key === "Enter" && (t.preventDefault(), t.stopPropagation());
                      },
                      ...h,
                      ...W
                    }
                  ),
                  /* @__PURE__ */ P(Oe, { children: [
                    w.length > 0 && !a && /* @__PURE__ */ o(
                      Ie,
                      {
                        onClick: G,
                        disabled: a,
                        "aria-label": "clear",
                        $isOffsetRequired: b !== "small",
                        children: /* @__PURE__ */ o(ie, { height: "16px", width: "16px" })
                      }
                    ),
                    /* @__PURE__ */ o(
                      Pe,
                      {
                        $isDisabled: a,
                        "aria-label": "dropdown",
                        size: b,
                        children: u ? /* @__PURE__ */ o(se, {}) : /* @__PURE__ */ o(le, {})
                      }
                    )
                  ] })
                ] })
              ] })
            }
          ) }),
          i.map((t, I) => /* @__PURE__ */ o(
            E.Item,
            {
              id: t.value,
              isSelected: !!w.includes(t.value),
              label: t.label,
              value: t.value,
              description: t.description
            },
            t.value
          ))
        ]
      }
    ),
    /* @__PURE__ */ o(
      $e,
      {
        secondaryProp: p?.secondaryProp,
        defaultProp: p?.defaultProp
      }
    )
  ] });
}, De = d.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`, oe = d.span`
  cursor: pointer;
`, Te = d.span`
  cursor: pointer;
  display: flex;
  align-items: center;
  &:focus {
    outline: none;
    svg {
      outline: 2px solid
        ${({ theme: e }) => e.components.selectInput.focusBorder};
      outline-offset: 2px;
      border-radius: ${ae["1x"]};
    }
  }
`, Re = d(ie)`
  margin-left: -${n["6x"]};
  height: ${n["4x"]} !important;
  width: ${n["4x"]} !important;
  padding: 0 ${n["1x"]};
  background: ${({ theme: e }) => e.components.selectInput.background};
  color: ${({ theme: e }) => e.components.selectInput.iconColor} !important;
  box-sizing: content-box !important;
`, He = "SingleSelect", je = (e, v) => {
  let a = e.trimStart();
  return a = a?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), v.filter(
    (i) => `${i.label}${i.value}`.search(new RegExp(a, "i")) < 0
  ).map((i) => i.value);
}, xt = ({
  errorMessage: e,
  placeholder: v = "Select...",
  isDisabled: a = !1,
  options: i,
  onChange: f,
  onBlur: A,
  selected: $ = "",
  onOptionSelect: b,
  size: L = "medium",
  helperText: O,
  isRequired: D = !1,
  required: j = D,
  maxItems: T = 8,
  className: M = "",
  labelProp: F,
  infoProp: N,
  trailingText: Q,
  isSearchable: X = !0,
  noResultText: z,
  showClear: B = !1,
  isDefaultSelect: K = !1,
  helperTextProp: R = {
    ...O && { defaultProp: { helperText: O } },
    ...e && {
      secondaryProp: { helperText: e, state: "error" }
    }
  },
  ...p
}) => {
  const h = V(ue(p.id ?? He)), [g, w] = C([]), [l, x] = C(!1), [y, u] = C(""), S = V(null);
  let m = { label: "", value: "" };
  const J = ce("combobox", {
    ariaExpanded: l,
    ariaDisabled: a,
    ariaRequired: D || F?.showRequiredIndicator || j,
    ariaInvalid: !!e,
    ariaHasPopup: "listbox",
    ariaControls: h.current
  }), W = (r) => {
    r.preventDefault(), r.stopPropagation(), u(""), b({ label: "", value: "" }), Object.defineProperty(r, "target", {
      value: m
    }), r.target = { value: JSON.stringify(m) }, f && f(r), S?.current && S.current?.querySelector("input")?.focus();
  }, G = (r) => {
    if (r.key !== "Enter")
      r?.preventDefault();
    else if (l && K) {
      if (r?.preventDefault(), r?.stopPropagation(), i.length === g.length)
        return;
      b(m);
      const t = new Event("change", {});
      Object.defineProperty(t, "target", {
        value: m,
        writable: !0
      }), t.target = { value: m }, f && f(t), x(!1);
    }
    r.key === " " && r?.stopPropagation(), r.key !== "Tab" && r.key !== "Shift" && !l && x(!0);
  }, Y = (r) => {
    r.currentTarget.contains(r.relatedTarget) || A?.(r);
  };
  _(() => {
    if (l)
      u("");
    else {
      let r = $;
      i.forEach((t, I) => {
        t.value === $ && (r = t.label);
      }), u(r);
    }
  }, [$, l, i]), _(() => {
    w(je(y, i));
  }, [y, i]);
  const Z = () => {
    let r = !0, t = { ...m };
    const I = i.map((c, de) => {
      let ee = r && $ === c.value && !g.includes(c.value);
      return $ === c.value && (t = { label: c.label, value: c.value }), K && r && !c.disabled && !g.includes(c.value) && (r = !1, ee = !0, m = { label: c.label, value: c.value }), /* @__PURE__ */ o(
        E.Item,
        {
          label: c.label,
          value: c.value,
          description: c.description,
          isSelected: ee,
          disabled: c.disabled || !1
        },
        de
      );
    });
    return r && (m = { ...t }), I;
  };
  return /* @__PURE__ */ o(De, { className: M, onBlur: Y, ...p, children: /* @__PURE__ */ P(
    E,
    {
      onChange: (r, t) => {
        r?.preventDefault(), b(t), f && f(r);
      },
      menuOpen: l,
      handleMenuOpen: (r) => x(r),
      closeOnSelect: !0,
      isDisabled: a,
      maxItems: T,
      uniqueIdentifier: h.current,
      hiddenItems: g,
      noResultText: z,
      children: [
        /* @__PURE__ */ o(E.Control, { children: /* @__PURE__ */ o(
          xe,
          {
            labelProp: { htmlFor: p.id || h.current, ...F },
            infoProp: {
              infoText: "",
              infoType: "tooltip",
              popupTipHeader: "Info",
              ...N
            },
            trailingText: Q,
            disabled: a,
            textSize: L,
            isInvalid: !!e,
            helperText: l ? "" : O,
            helperTextProp: l ? {} : R,
            required: D || j,
            id: `control-${h.current}`,
            placeholder: v,
            onChange: (r) => {
              u(r.target.value);
            },
            onKeyUp: G,
            value: y,
            ref: S,
            readOnly: !X,
            ...J,
            endAdornmentProp: {
              onClick: (r) => {
                r.preventDefault(), r.stopPropagation(), x(!l);
              },
              endAdornment: l ? /* @__PURE__ */ o(oe, { children: /* @__PURE__ */ o(se, { style: { pointerEvents: "none" } }) }) : /* @__PURE__ */ P(pe, { children: [
                !l && B && y?.trim() && /* @__PURE__ */ o(
                  Te,
                  {
                    tabIndex: 0,
                    onKeyUp: (r) => {
                      r.preventDefault(), r.stopPropagation(), (r.key === "Enter" || r.key === " ") && W(r);
                    },
                    "data-testid": "data-close-icon",
                    onClick: W,
                    children: /* @__PURE__ */ o(Re, {})
                  }
                ),
                /* @__PURE__ */ o(oe, { children: /* @__PURE__ */ o(le, { style: { pointerEvents: "none" } }) })
              ] })
            }
          }
        ) }),
        Z(),
        /* @__PURE__ */ o(be, { role: "alert", "aria-live": "assertive", children: y })
      ]
    }
  ) });
};
export {
  bt as MultiSelectInput,
  xt as SingleSelectInput
};
